import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const STORAGE_KEY = 'ExpandNavSideBar';

@Injectable({
    providedIn: 'root'
})
export class NavSidebarExpandedService {
    private _subject = new BehaviorSubject<boolean>(this.getValue());

    constructor() { }

    public toggleExpanded(): void {
        const newValue = !this.getValue();
        localStorage.setItem(STORAGE_KEY, JSON.stringify(newValue));
        this._subject.next(newValue);
    }

    public get toggled(): Observable<boolean> {
        return this._subject;
    }

    private getValue(): boolean {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'true');
    }


}
